import axios, { AxiosInstance, AxiosError } from "axios";

const getBaseUrl = (): string => {
  const explicitBaseUrlRaw =
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL;
  const explicitBaseUrl = typeof explicitBaseUrlRaw === "string" ? explicitBaseUrlRaw.trim() : "";
  // Some deployments set these to "0" to indicate "use default/proxy".
  // Treat that as unset; otherwise the app will request URLs like `0/api/message`.
  if (explicitBaseUrl && explicitBaseUrl !== "0") {
    return explicitBaseUrl.replace(/\/+$/, "");
  }

  const hostname = window.location.hostname;
  if (hostname !== "localhost" && hostname !== "127.0.0.1") {
    return "";
  }

  return "http://localhost:8080";
};

export const api: AxiosInstance = axios.create({
  baseURL: getBaseUrl(),
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const apiKey = localStorage.getItem("secai_api_key") || "dev-api-key";
    config.headers["X-API-Key"] = apiKey;

    const sessionToken = localStorage.getItem("secai_session_token");
    if (sessionToken) {
      config.headers["X-Session-Token"] = sessionToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    console.error("API Error:", {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
    });

    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("secai_api_key");
      localStorage.removeItem("secai_session_token");
    }

    return Promise.reject(error);
  }
);

export const checkApiHealth = async (): Promise<boolean> => {
  try {
    const response = await api.get("/api/health");
    return response.data.status === "healthy";
  } catch {
    return false;
  }
};

export default api;
